/* Buy 3, get 1 free. Shopify's automatic discount is authoritative at checkout. */
(function (root) {
  'use strict';
  function quantity(value) {
    const count = Number(value);
    return Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
  }
  function offerFor(value) {
    const count = quantity(value);
    const free = Math.floor(count / 4);
    const remainder = count % 4;
    return {count, free, remaining: 4 - remainder, qualifies: free > 0,
      progress: count && !remainder ? 100 : remainder / 4 * 100};
  }
  function quote(prices, displayOffer = false) {
    const values = prices.map(price => Number.isFinite(Number(price)) ? Math.max(0, Math.round(Number(price))) : 0);
    const offer = offerFor(values.length);
    const list = values.reduce((sum, price) => sum + price, 0);
    // Advertised bundle prices opt in. Cart and checkout totals still come from Shopify.
    const saved = displayOffer ? values.slice().sort((a, b) => a - b)
      .slice(0, offer.free).reduce((sum, price) => sum + price, 0) : 0;
    const after = list - saved;
    return {...offer, n: values.length, list, before: list, saved, after,
      each: values.length ? Math.round(after / values.length) : 0};
  }
  function strings() {
    try { return JSON.parse(root.document.getElementById('ld-savings-config').textContent); }
    catch (_) { return {}; }
  }
  function format(copy, values) {
    return Object.entries(values).reduce((text, [key, value]) => text.replaceAll(`[${key}]`, String(value)), copy);
  }
  function label(value, copy = strings()) {
    const {free} = offerFor(value);
    if (!free) return copy.heading || 'Buy 3, get 1 free';
    return format(free === 1 ? (copy.freeOne || '1 free item') : (copy.freeMany || '[count] free items'), {count: free});
  }
  function message(value, copy = strings()) {
    const offer = offerFor(value);
    const next = format(copy.next || 'Add [count] more to get 1 free.', {count: offer.remaining});
    if (!offer.free) return next;
    const unlocked = format(copy.unlocked || '[reward] unlocked.', {reward: label(value, copy)});
    return offer.count % 4 ? unlocked + ' ' + next : unlocked;
  }
  const api = Object.freeze({quantity, offerFor, quote, label, message});
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.LiftDownSavings = api;
})(typeof window !== 'undefined' ? window : null);
